__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__Q3__Mq__freeBox",
  "root": "PlasmicDescription-module__Q3__Mq__root",
});
